import { useState } from 'react';
import { ImageList, ImageListItem } from '@mui/material';
import { ImageLightbox } from './image-lightbox';
import { ensureHttps } from '@core/utils/formatting';
import type { ImageResponse } from '@core/types/ticket';

interface ImageGridProps {
  images: ImageResponse[];
}

export function ImageGrid({ images }: ImageGridProps) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageClick = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <ImageList cols={3} gap={8} sx={{ mt: 1 }} id="image-grid">
        {images.map((image, index) => (
          <ImageListItem
            key={index}
            onClick={() => handleImageClick(index)}
            sx={{
              cursor: 'pointer',
              '&:hover': { opacity: 0.8 },
              transition: 'opacity 0.2s',
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            <img
              src={ensureHttps(image.file_url)}
              alt={image.description || `Ảnh ${index + 1}`}
              loading="lazy"
              style={{
                width: '100%',
                aspectRatio: '1/1',
                objectFit: 'cover',
                borderRadius: 8,
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>

      <ImageLightbox
        open={lightboxOpen}
        images={images}
        currentIndex={currentImageIndex}
        onClose={() => setLightboxOpen(false)}
        onNavigate={setCurrentImageIndex}
      />
    </>
  );
}
